import _ from '@lodash';
import Icon from '@material-ui/core/Icon';
import IconButton from '@material-ui/core/IconButton';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { navbarFolded } from 'app/store/fuse/navbarSlice';
import { saveCookie } from 'app/util/utils';
import { NAVBAR_FOLDED } from 'app/util/consts';

function NavbarFoldedToggleButton(props) {
	const dispatch = useDispatch();
	const navbar = useSelector(({ fuse }) => fuse.navbar);

	return (
		<IconButton
			className={props.className}
			onClick={() => {
				dispatch(navbarFolded(!navbar.folded));
				saveCookie(NAVBAR_FOLDED, !navbar.folded);
			}}
			color="inherit"
			size="small"
		>
			{props.children}
		</IconButton>
	);
}

NavbarFoldedToggleButton.defaultProps = {
	children: <Icon fontSize="inherit">push_pin</Icon>
};

export default NavbarFoldedToggleButton;
